(function () {
  'use strict';

  // Pointer spotlight for c-dot-grid hosts that opt in with
  // [data-dot-grid-spotlight]. On move, write the host-relative cursor position
  // into --c-dot-grid-mx / --c-dot-grid-my (read by the masked ::after in
  // component-common-dot-grid.css). All rendering stays in CSS; this only tracks.
  function init() {
    const hosts = document.querySelectorAll('[data-dot-grid-spotlight]');
    if (!hosts.length) return;

    hosts.forEach(function (host) {
      function move(event) {
        const rect = host.getBoundingClientRect();
        host.style.setProperty('--c-dot-grid-mx', (event.clientX - rect.left) + 'px');
        host.style.setProperty('--c-dot-grid-my', (event.clientY - rect.top) + 'px');
        host.dataset.dotGridActive = 'true';
      }

      function leave() {
        host.dataset.dotGridActive = 'false';
      }

      host.addEventListener('pointermove', move);
      host.addEventListener('pointerleave', leave);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
})();
